export enum Nationality {
  Egyptian = 'EGYPTIAN',
  Saudi = 'SAUDI',
  Indian = 'INDIAN',
  Pakistani = 'PAKISTANI',
  Bangladeshi = 'BANGLADESHI',
  Kuwaiti = 'KUWAITI',
  Sudanese = 'SUDANESE',
  Syrian = 'SYRIAN',
  Yemeni = 'YEMENI',
  Nepali = 'NEPALI',
  SriLankan = 'SRI_LANKAN',
  Philippines = 'PHILIPPINES',
  Afghanistan = 'AFGHANISTAN',
  Eritrean = 'ERITREAN',
  jordan = 'JORDAN',
  Others = 'OTHERS'
}
